import React from "react";
import { AboutIntroContainer } from "./AboutIntro.style";
import HeadingWithIcon from "Components/landing_page/HeadingWithIcon";
import CustomButton from "Components/Commons/CustomButton/CustomButton";
import VideoSection from "Components/Commons/VideoSection/VideoSection";

// Images
import IntroImage from "../../Assets/Images/VideoSection/subject_master_founder_thumb.png";
import VideoIconImg from "../../Assets/Images/VideoSection/video_icon.svg";

// Video
import { useNavigate } from 'react-router-dom';

import AboutUsIntroVideo from "../../Assets/Sounds/about-us-intro.mp4";

const AboutIntro = () => {
	const navigate = useNavigate();
	const handleSubscriptionClick = () => {
		navigate("/subscription");
	};

	return (
		<AboutIntroContainer>
			<div className="aboutintro_main">
				<div className="mygrid-container">
					<div className="mygrid-row">
						<div className="mygrid-col-md-12">
							<div className="about_intro_content">
								<h5 className="subheading">Who We Are</h5>
								<HeadingWithIcon highlight="Subjects Master">About</HeadingWithIcon>
								<h4 className="about-intro_subtxt">
									<span className="redfont">Empowering Teachers</span> and Motivating Students
								</h4>
								<p>
									Subjects Master is driven by a generational way of learning, through instructional content and gaming and by bringing an entertaining aspect to the information a
									user needs to master multiple subjects. Our themed multiple course learning makes Civics engaging, Math amazing, English enjoyable, History historical, Science
									exciting, Economics defining and Foreign Language inspiring. Being proficient in various subjects will broaden an individual’s ability to forward think. Subjects
									Master is looking forward to its users developing a sustainable passion for learning, by acquiring the knowledge and expertise that will propel them to the next
									level and by motivating and inspiring its users to become resourceful in their study and ambitious in their goals.
								</p>
								<p>
									Subjects Master focus is to empower educators to embrace the dynamics of technology teaching by providing a platform in which they control the content. Implementing
									these two components guarantees a compelling way of learning and allows the educator to be the decision maker on how Subjects Master can be used effectively with
									in-class instruction. Integrating technology with in-class instruction will reinforce what an educator is teaching and will enhance a student’s ability to retain
									the information.
								</p>
								<p>
									<strong>Knowledge is Power and a user that feels empowered will also feel motivated to learn.</strong>
								</p>
								<CustomButton
									onClick={handleSubscriptionClick}
									text="Subscription Plans"

								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="video_section_founder">
				<VideoSection
					subheading=""
					title="The Founder"
					highlight=""
					tagline=""
					description={[
						"At Subjects Master, every feature starts with a simple belief: learning should be fun, interactive, and engaging. Our founder, Tanisha Ferguson, created this platform to empower teachers, inspire students, and reimagine education through interactive tools and game-based learning. In this short video, Tanisha shares the vision and story behind Subjects Master and how we turn traditional study time into dynamic game time, making education both effective and enjoyable.",
					]}
					buttonText=""
					buttonLink=""
					introImage={IntroImage}
					videoIcon={VideoIconImg}
					videoSrc={AboutUsIntroVideo}
				/>
			</div>
		</AboutIntroContainer>
	);
};

export default AboutIntro;
